<template>
    <template v-if="isMobile">
        <!-- <Sticky
            :top="45.59"
            stickyClass="scroll_top_logo"
            :stickyShowBefore="false"
            v-if="scrollTop > 45.59"
            >
            <MobileHeader :mobileHeaderTitle="playerInfo.name" ></MobileHeader>
        </Sticky> -->
        <MobileHeader
            class="player-mobile-header"
            :mobileHeaderTitle="''"
            :isShowFavButton="true"
            :isFav="isFav"
            @toggleFavThis="toggleFavPlayer($event)"
        >
        </MobileHeader>
    </template>

    <LoadingAspn type="player" v-if="isLoading" />
    <div class="play-index-container" v-else>
        <div class="play-index-box">
            <div class="player-content">
                <div class="player-data">
                    <div class="player-img">
                        <Icon
                            :category="'player'"
                            :logoUrl="playerInfo.logo"
                            class="info-logo__img"
                        ></Icon>
                    </div>
                    <div class="player-name">
                        <div class="player-value">{{ playerInfo.number }}</div>
                        <div class="player-name-text">
                            <div>{{ playerInfo.name }}</div>
                            <!-- <div class="bold">Haaland</div> -->
                        </div>
                        <div
                            class="btn-fav-aspn-circle fav-player"
                            v-if="!isMobile"
                            :class="{
                                selected: isFav,
                            }"
                            @click="toggleFavPlayer($event)"
                        ></div>
                    </div>
                    <!-- <div class="player-fav-box" @click="isFav = !isFav">
                        <template v-if="isMobile">
                            <img src="../../../../../static/images/icons/aspn_icon/player/icon_fav_mobile_selected.png"
                                v-if="isFav" />
                            <img src="../../../../../static/images/icons/aspn_icon/social_media/icon_favourite.png"
                                v-else />
                        </template>
                        <template v-else>
                            <img src="../../../../../static/images/icons/aspn_icon/player/icon_fav_selected.png"
                                v-if="isFav" />
                            <img src="../../../../../static/images/icons/aspn_icon/player/icon_fav.png"
                                v-else />
                        </template>
                        <div class="player-fav-followers">
                            <span class="bold">108</span> 
                            followers
                        </div>
                    </div> -->
                </div>
            </div>
            <div class="player-info">
                <div class="player-info-item">
                    <div class="player-info-title">
                        {{ $t("NATIONALITY") }}
                    </div>
                    <div class="player-info-data info-country">
                        <!-- <Icon :category="'country'" :logoUrl="playerInfo.countryLogo"></Icon> -->
                        <!-- <img src="../../../../../static/images/icons/aspn_icon/icon_avatar.png" class="flag" /> -->
                        <span v-show="!isMobile">
                            {{ playerInfo.nationality }}
                        </span>
                    </div>
                </div>
                <div class="player-info-item">
                    <div class="player-info-title">
                        {{ $t("POSITION") }}
                    </div>
                    <div class="player-info-data">
                        {{ playerInfo.position }}
                    </div>
                </div>

                <div class="player-info-item">
                    <div class="player-info-title">
                        {{ $t("HEIGHT") }}
                    </div>
                    <div class="player-info-data">
                        {{ playerInfo.height }}
                    </div>
                </div>
                <div class="player-info-item">
                    <div class="player-info-title">
                        {{ $t("WEIGHT") }}
                    </div>
                    <div class="player-info-data">
                        {{ playerInfo.weight }}
                    </div>
                </div>
                <div class="player-info-item">
                    <div class="player-info-title">
                        {{ $t("AGE") }}
                    </div>
                    <div class="player-info-data">
                        {{ playerInfo.age }}
                    </div>
                </div>
                <div class="player-info-item">
                    <div class="player-info-title">
                        {{ $t("DATE_OF_BIRTH") }}
                    </div>
                    <div class="player-info-data">
                        {{ playerInfo.birthdate }}
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div
        class="home has-header container player-container player__transfer-container"
    >
        <!-- <div class="info-logo__wrapper">
            <div class="info-logo__container">
                <Icon  :category="'player'" :logoUrl=playerInfo.logo  class="info-logo__img"></Icon>
            </div>
            <div class="team-info__header-title">{{playerInfo.name}}</div>
        </div> -->

        <!-- <div class=" display-flex has-space mb-2rem player-tab" v-if="!isMobile">
            <router-link class="sub-nav__child" :to="{path:`${o.path}`}"  v-for="(o, index) in tabs" :key="index" >
                <span  class="sub-nav__child-text">{{$t(o.name)}}</span>
                <div class="sub-nav__child-indicator"></div>
            </router-link>
        </div>
        <Sticky
            v-else
            :top="43.19 + 196"
            stickyClass="scroll_top_tabs"
            :stickyShowBefore="true">
            <div class=" display-flex has-space mb-2rem player-tab">
                <router-link class="sub-nav__child" :to="{path:`${o.path}`}"  v-for="(o, index) in tabs" :key="index" >
                    <span  class="sub-nav__child-text">{{$t(o.name)}}</span>
                    <div class="sub-nav__child-indicator"></div>
                </router-link>
            </div>
        </Sticky> -->

        <div>
            <router-view></router-view>
        </div>
    </div>

    <PopUpSignInIndexMobile
        ref="PopUpSignInIndexMobileRef"
        :title="$i18n.t('FAV_LOGIN_TITLE')"
        :message="$i18n.t('FAV_LOGIN_TIPS')"
        class="login-fav-popup"
    ></PopUpSignInIndexMobile>
</template>
<script>
import { mapState, mapGetters, mapActions } from "vuex";
import MobileHeader from "@/components/mobile/Header.vue";
import PopUpSignInIndexMobile from "@/components/user/PopUpSignInIndexMobile.vue";

export default {
    components: {
        MobileHeader,
        PopUpSignInIndexMobile,
    },
    watch: {
        async currentLanguageObj(newVal) {
            this.isLoading = true;
            await this.init();
            this.isLoading = false;
        },
    },
    data() {
        return {
            isLoading: false,
            mobileHeaderTitle: "PLAYER",
            isFav: false,
            playerKey: "",
            tabs: [
                {
                    name: "OVERVIEW",
                    path: "overview",
                    value: 1,
                    selected: true,
                },
                // { // YIM - AS-1041
                //     name:'CAREER',
                //     value:2,
                //     path:'career',
                //     selected:false
                // },
                {
                    name: "STATS",
                    path: "stats",
                    value: 2,
                    selected: false,
                },
                {
                    name: "NEWS",
                    path: "news",
                    value: 3,
                    selected: false,
                },
                {
                    name: "MATCHES",
                    path: "matches",
                    value: 4,
                    selected: false,
                },
            ],
        };
    },
    created() {
        this.playerKey = this.$route.params.player;
    },

    computed: {
        ...mapState(["scrollTop"]),
        ...mapGetters([
            "isMobile",
            "isLogin",
            "playerInfo",
            "currentLanguageObj",
        ]),
    },
    mounted() {
        this.init();
    },
    methods: {
        ...mapActions([
            "getPlayerInfo",
            "unFavPlayer",
            "addFavPlayer",
            "toastrFavChangeEvent",
        ]),
        async init() {
            await this.getPlayerInfoData();
            this.generateTabs();
        },
        generateTabs() {
            if (this.isMobile) {
                this.tabs.push({
                    name: "CAREER",
                    path: "career",
                    value: 5,
                    selected: false,
                });
            } else {
                // if(this.$route.name === "footballPlayerCareer") {
                //     let params = JSON.parse(JSON.stringify(this.$route.params))
                //     this.$router.replace({
                //         name: 'footballPlayerOverview',
                //         params: params,
                //     }).then(() => {
                //     }).catch(err => {
                //     });
                // }
            }
        },
        async getPlayerInfoData() {
            this.isLoading = true;
            let params = {
                playerId: this.playerKey,
            };
            await this.getPlayerInfo(params);
            let leagueId = this.playerInfo.leagueId;
            let leagueName = this.playerInfo.leagueName;
            this.playerInfo["leagueKey"] =
                leagueName.toLowerCase().replace(/\s+/g, "-") + `-${leagueId}`;
            this.isFav = this.playerInfo.isFavPlayer;
            setTimeout(() => {
                this.isLoading = false;
            }, 500);
        },
        async toggleFavPlayer(level2, event) {
            if (this.isLogin) {
                let params = {
                    playerId: this.playerKey,
                };
                let paramsToastr = {
                    isOpen: true,
                    msg: this.playerInfo.name,
                    isAddedFav: false,
                };
                if (this.isFav) {
                    const result = await this.unFavPlayer(params);
                    if (result.message === "Success") {
                        this.isFav = false;

                        paramsToastr.isAddedFav = false;
                        this.toastrFavChangeEvent(paramsToastr);
                    }
                } else {
                    const result = await this.addFavPlayer(params);
                    if (result.message === "Success") {
                        this.isFav = true;

                        paramsToastr.isAddedFav = true;
                        this.toastrFavChangeEvent(paramsToastr);
                    }
                }
            } else if (!this.isLogin && !this.isMobile) {
                this.$refs.PopUpSignInIndexMobileRef.handleOpen();
            } else if (!this.isLogin && this.isMobile) {
                this.$refs.PopUpSignInIndexMobileRef.handleOpen();
            }
        },
    },
};
</script>

<style scoped>
.team-info__header-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    margin-bottom: 2rem;
}

.team-info__header-title {
    font-size: 1.2rem;
    font-family: var(--weight-700);
}
.team-info__overview-card {
    margin-bottom: 2rem;
}

.team-info__overview-header {
    margin: 0 1rem;
    margin-bottom: 1.45rem;
    font-size: 0.87rem;
    font-family: var(--weight-400);
}
.team-info__overview-body {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 0.7rem;
    padding: 0.8rem 0.5rem;
    border-bottom: 0.1rem solid #212b30;
    color: var(--color-grey-light);
    margin: 0 0.5rem;
}
.team-info__overview-body__header {
    display: flex;
    justify-content: space-between;
    background-color: var(--color-grey-20);
    padding: 0.5rem 1rem;
}
.team-info__overview-body:last-child {
    border-bottom: none;
}
.team-info__overview-goal__player {
    display: flex;
    align-items: center;
    font-size: 0.85rem;
    flex: 2;
}
.team-info__overview-goal__player-rank {
    margin-right: 0.8rem;
    width: 1rem;
    text-align: center;
}
.team-info__overview-goal__player-img {
    border-radius: 50%;
    overflow: hidden;
    margin-right: 0.5rem;
}
.team-info__overview-goal__player-goal {
    font-size: 0.85rem;
}

.player-container {
    padding-top: 0;
    /* border-radius: 16px;
        padding: 1rem;
        background-color: var(--white-1000);
        margin: 1rem auto; */
}
.player-container .team-info__overview-body {
    color: var(--text-default-default);
    background-color: red;
}
.player-container .player__transfer-table__body-child {
    color: var(--text-default-default);
}
.player-container .player__transfer-table__body-child {
    color: var(--text-default-default);
}
@media(max-width: 768px) {
    /* for test */
    .player-container {
        /* margin: 3.7rem .5rem 0 .5rem; */
        margin: 0;
    }
    .player-tab.has-space {
        margin: 0;
    }
}
</style>

<style scoped>
.play-index-container {
    width: 100%;
    background: linear-gradient(
        180deg,
        var(--color-background-default-secondary) 90%,
        transparent
    );
    color: var(--color-text-default-default);
}
.play-index-box {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-image: url("../../../../../static/images/icons/aspn_icon/player/player_bg.png");
    background-size: auto 500px;
    background-position: top;
    background-repeat: no-repeat;
}
.player-content {
    display: flex;
    /* width: 1200px; */

    margin: auto;
    padding-top: 75.92px;
}
.player-data {
    /* max-width: 293px; */
    width: 1200px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 16.17px;
}
.player-name {
    display: flex;
    align-items: center;
    gap: 24px;
    font-size: 48px;
    font-family: var(--weight-700);
    letter-spacing: -0.64px;
    line-height: 120%;
}
.player-value {
    font-size: 128px;
    font-family: var(--weight-700);
}
.player-name-text {
}
.bold {
    font-family: var(--weight-700);
}
.player-fav-box {
    width: 215px;
    height: 40px;
    background: linear-gradient(90deg, #000 0%, #28a745 100%);
    display: flex;
    align-items: center;
    border-radius: 20px;
    position: relative;
    margin: 19px 0 29px 25px;
    cursor: pointer;
}
.player-fav-box img {
    height: 100%;
    transform: scale(1.6) translate3d(-25%, 0, 0);
}
.player-fav-followers {
    color: #fff;
    font-size: 22.4px;
    padding-left: 8px;
}
.player-img {
    /* background-image: url('../../../../../static/images/icons/aspn_icon/player/player_bg.png');
    background-position: center;
    background-size: 100%;
    background-repeat: no-repeat;
    margin: 0 96px 0 57px; */
    border-radius: 50%;
    width: 188px;
    height: 188px;
}
.player-img img {
    width: 500px;
    display: inherit;
}
.player-info {
    padding-top: 30px;
    padding-bottom: 80px;
    display: flex;
    align-items: baseline;
    justify-content: center;
    gap: 60px;
}
.player-info-item {
    margin-bottom: 24px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}
.player-info-item:last-child {
    margin-bottom: 0;
}
.player-info-title {
    font-size: 14px;
    color: #6c757d;
    letter-spacing: 0.64px;
}
.player-info-data {
    font-size: 24px;
    font-family: var(--weight-600);
    margin-top: 4px;
    letter-spacing: -0.64px;
}
.flag {
    width: 30px;
    margin-right: 8px;
}
.info-country {
    display: flex;
    align-items: center;
}

.player-tab {
    background-color: var(--color-background-default-secondary);
    padding: 24px 24px 0 24px;
    border-radius: 16px;
}
.player-tab .sub-nav__child {
    padding: 0 16px;
    margin-right: 0;
}
.sub-nav__child-indicator {
    margin-top: 8px;
}
.fav-player {
    width: 56px;
    flex-shrink: 0;
    height: 56px;
}

@media(max-width: 768px) {
    /* for test */
    .player-tab {
        padding: 16px 0 0;
        border-radius: 0;
        border-bottom: 1px solid var(--gray-300);
        justify-content: center;
    }
    .player-info {
        display: none;
    }
    .player-overview-container {
        display: block;
    }
    .player-img {
        width: 114.6px;
        height: 114.6px;
        /* position: absolute; */
        /* top: 0; */
        /* left: 0; */
        /* margin: 0; */
        background-position: center;
        background-size: auto 100%;
        background-repeat: no-repeat;
        display: flex;
        justify-content: right;
        flex-shrink: 0;
    }
    .player-img img {
        width: 220px;
        height: 220px;
        margin: 0;
    }
    .player-content {
        width: 100%;
        position: relative;
        /* margin-top: 45.59px; */
        padding-top: 0;
        min-height: 140px;
    }
    .player-data {
        max-width: unset;
        margin: 0 16px;
        position: relative;
        z-index: 3;
        /* flex-direction: row-reverse; */
        justify-content: flex-start;
        width: 100%;
        gap: 20.96px;
    }
    .player-value {
        font-size: 32px;
        font-family: var(--weight-700);
        letter-spacing: -0.64px;
        line-height: 120%;
    }
    .player-name {
        gap: 0;
        display: flex;
        flex-direction: column-reverse;
        align-items: baseline;
    }
    .player-name-text {
        font-size: 20px;
        line-height: 120%;
        font-family: var(--weight-600);
    }
    .player-info-title,
    .player-info-data {
        display: none !important;
    }
    .info-country {
        display: block !important;
    }
    .player-fav-box {
        width: 140px;
        height: 32px;
        margin: 21px 0 16px;
    }
    .player-fav-box img {
        transform: scale(1) translate3d(-25%, 0, 0);
    }
    .player-fav-followers {
        font-size: 14px;
        padding-left: 0;
        letter-spacing: 0.64px;
    }
    .player-info-data {
        display: flex;
        margin-top: 0;
        align-items: center;
    }
    .flag {
        width: 44px;
    }
    .player-info-item {
        margin-bottom: 0;
    }
    .player-tab .sub-nav__child {
        padding: 0 12px;
    }
    .scroll_top_logo {
        left: 50%;
        transform: translate3D(-50%, 0, 0);
        top: 2px;
    }
    .scroll_top_tabs {
        top: 43.19px;
        width: 100%;
    }
    .sub-nav__child-indicator {
        margin-top: 16px;
    }
    .play-index-box {
        background-size: auto 220px;
    }
}
</style>

<style>
.player-mobile-header .nav-header__title {
    color: var(--color-text-default-default);
}
.player-img .icon-player .img-contain {
    border-radius: 50%;
}
</style>

<style scoped>
.icon-league {
    margin-right: 8px;
}
</style>
